import { useEffect, useMemo, useRef, useState } from 'react';
import {
  MaterialReactTable,
  useMaterialReactTable,
  type MRT_ColumnDef,
  type MRT_TableOptions,
} from 'material-react-table';
import {
  Pagination,
  Typography,
  TextField,
  Button,
  Box,
  InputAdornment,
  useMediaQuery,
  PaginationItem,
  Menu,
  MenuItem,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
} from '@mui/material';
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg';
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg';
import download from 'packages/novous_web/src/assets/icons/download.svg';
import add from 'packages/novous_web/src/assets/icons/add.svg';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import { useLocation, useNavigate } from 'react-router-dom';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { useAuth } from 'packages/novous_web/src/authContext/useAuth';
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import bulkUpload from 'packages/novous_web/src/assets/icons/bulkUpload.svg';
import car from '../../../../assets/images/car.svg';
import truck from '../../../../assets/images/truck.svg';
import minivan from '../../../../assets/images/minivan.svg';
import bus from '../../../../assets/images/bus.svg';
import MapPreview from '../../Home/components/MapPreview';
import live from 'packages/novous_web/src/assets/icons/Live.svg';
import eye from 'packages/novous_web/src/assets/icons/Eye.svg';

import share from 'packages/novous_web/src/assets/icons/Share.svg';
import Devices from 'packages/novous_web/src/assets/icons/Devices.svg';

import menu from 'packages/novous_web/src/assets/icons/menu.svg';
import Delete from 'packages/novous_web/src/assets/icons/Delete.svg';
import LiveFeedModal from '../../Reports/components/LiveFeed';
import edit from 'packages/novous_web/src/assets/icons/edit.svg';
import location from 'packages/novous_web/src/assets/icons/Location.svg';
import callingIcon from 'packages/novous_web/src/assets/icons/phone-calling.svg';
import CallingModal from 'packages/novous_web/src/common/components/CallingModal';
import AlertToast from 'packages/novous_web/src/common/components/Alert';
import dashboard from 'packages/novous_web/src/assets/icons/DashboardIcon.svg';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import UploadDriverDocModal from 'packages/novous_web/src/common/components/UploadDriverDoc';
import BulkUploadModal from 'packages/novous_web/src/common/components/BulkUpload';
import play from 'packages/novous_web/src/assets/icons/Play.svg';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';
import useApiError from 'packages/novous_web/src/api/useApiError';
import ShareLinkModalBox from './ShareLinkModalBox';
import { Endpoint } from 'aws-sdk/lib/endpoint';
import axisInstance from 'packages/novous_web/src/api/apiClient';

interface MapData {
  vehicleRegistrationNo: string;
  lastUpdateTime: string;
  lastLatitude: string;
  lastLongitude: string;
  vehicleState: string;
  deviceId: string;
  gpsSpeed: number;
  vehicleType: string;
  deviceType: string;
}

interface Vehicle {
  vehicleName: string;
  driverName: string;
  gpsSpeed: number;
  vehicleRegistrationNo: string;
  vehicleType: string;
  lastLocationAddress: string;
  vehicleState: string;
  lastLatitude: string;
  lastLongitude: string;
  groupName: string;
  chassisNo: string;
  deviceType: string;
  modelYear: string;
  model: string;
  vehicleManufacturer: string;
  lastUpdateTime: string;
  deviceId: string;
  tripStatus: string;
  totalKmToday: string;
  tripName: string;
  tripId: string;
  isDeviceWakeupTriggered?: boolean;
  deviceWakeupTriggered?: boolean;
  dataSource?: string;
  vehicleProductType: string;
}

type ColumnObjType = {
  [key: string]: {
    name: string;
    status: boolean;
  };
};

const VehiclesDataTable = ({ mapView, handleTile, filterData, setFilterData }: any) => {
  const [alertOpen, setAlertOpen] = useState<boolean>(false);
  const [alertMessage, setAlertMessage] = useState<string>('');
  const [alertType, setAlertType] = useState<'error' | 'success' | 'warning' | 'info'>('error');
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const [isShareLikOpen, setIsShareLinkOpen] = useState(false);
  // Note: Wake-up status is now tracked using predefined fields:
  // "isDeviceWakeupTriggered": false,
  // "deviceWakeupTriggered": false,

  const pageLocation = useLocation();
  const params = new URLSearchParams(pageLocation.search);
  const redirectedStatus: any = params.get('status');
  const [searchQuery, setSearchQuery] = useState(redirectedStatus || '');
  const [data, setData] = useState<Vehicle[]>([]);
  const [mapData, setMapData] = useState<MapData[]>([]);
  const [isLiveFeedOpen, setIsLiveFeedOpen] = useState({ isOpen: false, vehicleId: '' });
  const [filteredData, setFilteredData] = useState<Vehicle[]>([]);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedVehicle, setSelectedVehicle] = useState<any>(null);
  const isSmallScreen = useMediaQuery('(max-width:850px)');
  const [currentPage, setCurrentPage] = useState(1);
  const [pagesData, setPagesData] = useState<Vehicle[][]>([]);
  const paginatedArr = useRef<any[]>([null]);
  const [isUploadModelOpen, setIsUploadModelOpen] = useState(false);
  const [driverDoc, setDriverDoc] = useState<any>();
  const pageSize = 10;
  const { user } = useAuth();
  // const [filterData, setFilterData] = useState<{ data: any, isfiltered: boolean }>({ data: {}, isfiltered: false });

  const navigate = useNavigate();
  const [wakeupSendingVehicleIds, setWakeupSendingVehicleIds] = useState<string[]>([]);
  const [isFilterModel, setIsFilterModelOpen] = useState(false);
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const [vehicleLive, setVehicleLive] = useState<any>();
  const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);
  const [columnObj, setColumnObj] = useState<ColumnObjType>({
    vehicleName: { name: 'Vehicle Name', status: true },
    driverName: { name: 'Driver Name', status: true },
    vehicleProductType: { name: 'Vehicle Product Type', status: true },
    groupName: { name: 'Depot Name', status: true },
    gpsSpeed: { name: 'Vehicle Speed', status: true },
    deviceId: { name: 'Device Id', status: true },
    lastUpdateTime: { name: 'Last Updated Time', status: true },
    vehicleRegistrationNo: { name: 'Vehicle Reg No', status: true },
    vehicleType: { name: 'Vehicle Icon', status: true },
    vehicleState: { name: 'Vehicle Status', status: true },
    lastLocationAddress: { name: 'Last Location', status: true },
    tripStatus: { name: 'Trip Status', status: true },
    actions: { name: 'Actions', status: true },
  });
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState<string>('pdf');
  const [singleVehicleDownload, setSingleVehicleDownload] = useState<any>(false);
  const [isVehicleLocationModalOpen, setVehicleLocationModalOpen] = useState<any>(false);
  const [vehicleFoucLocation, setVehicleFoucLocation] = useState<{ lat: number; lng: number } | undefined>(
    undefined,
  );
  const handleFilterClose = () => setIsFilterModelOpen(false);
  const handleFilterOpen = () => setIsFilterModelOpen(true);
  const navigateToDasboard = () => {
    navigate('dashboard', { state: selectedVehicle });
  };
  const handleLiveFeedOpen = (vehicleId: string) => {
    setIsLiveFeedOpen({ isOpen: true, vehicleId });
  };
  const navigateToEdit = () => {
    navigate('new', { state: selectedVehicle });
  };
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // State for delete modal
  const [toast, setToast] = useState({ open: false, message: '', type: 'error' }); // State for toast messages
  const paginatedData = useMemo(() => {
    const start = (currentPage - 1) * pageSize;
    const end = start + pageSize;
    return filteredData.slice(start, end);
  }, [filteredData, currentPage]);
  const {
    data: deleteVehicleData,
    error: deleteVehicleError,
    loading: deleteVehicleLoading,
    fetchData: fetchDeleteVehicleData,
  } = useAxios<any>(`${API_ENDPOINTS.directories.DELETE_VEHICLE}`, 'POST');

  const handleDeleteConfirm = () => {
    if (selectedVehicle) {
      fetchDeleteVehicleData(selectedVehicle);
      setIsDeleteModalOpen(false);
    }
  };

  const handleDeleteCancel = () => {
    setIsDeleteModalOpen(false);
  };

  useEffect(() => {
    if (filterData?.isfiltered) {
      fetchVehicleData({
        fleetId: user?.customer_id,
        lastEvaluatedKey: null,
        vehicleId: filterData?.data?.vehicle,
        vehicleGroup: filterData?.data?.group,
        vehicleType: filterData?.data?.vehicleType,
        vehicleStatus: filterData?.data?.group,
      });
    } else {
      fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
    }
  }, [filterData, user?.customer_id]);

  console.info('filterData', filterData);

  const [tilesObj, setTilesObj] = useState<ColumnObjType>({
    Stat1: { name: 'Total Vehicles', status: true },
    Stat2: { name: 'Active Vehicles', status: true },
    Stat3: { name: 'Available Vehicles', status: true },
    Stat4: { name: 'Maintenance Vehicles', status: true },
  });

  useEffect(() => {
    if (deleteVehicleData?.data === 'success') {
      setToast({ open: true, message: 'Vehicle Deleted Successfully.', type: 'success' });
      setTimeout(() => {
        fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
      }, 1000);
    } else if (deleteVehicleError) {
      setToast({ open: true, message: 'Error occurred while deleting vehicle.', type: 'error' });
    }
  }, [deleteVehicleData, deleteVehicleError]);

  const handleVehicleLocationCancel = () => {
    setVehicleLocationModalOpen(false);
  };

  const handleFilterSave = (data: any) => {
    console.info(data, 'data');
    setFilterData({ data: data, isfiltered: true });
  };

  const [shareLink, setShareLink] = useState<string>('');
  const handleShareLink = () => {
    if (!selectedVehicle) return;

    const currentTime = new Date().toISOString();
    const link = `${window.location.origin}/vehicle/track/${
      selectedVehicle.vehicleRegistrationNo
    }?time=${encodeURIComponent(currentTime)}&lat=${selectedVehicle.lastLatitude}&lng=${
      selectedVehicle.lastLongitude
    }`;

    // navigator.clipboard.writeText(link)
    //     .then(() => {
    //         console.info('Link copied to clipboard:', link);
    //     })
    //     .catch(err => {
    //         console.error('Failed to copy link: ', err);
    //     });

    // window.open(link, '_blank');
    setShareLink(link);
    setIsShareLinkOpen(true);
  };

  const handelShareLinkModalOpen = () => {
    handleShareLink();
  };

  const handelShareLinkModalClose = () => {
    setIsShareLinkOpen(false);
  };

  const {
    data: wakeupDeviceData,
    error: wakeupDeviceError,
    loading: wakeupDeviceLoading,
    fetchData: fetchWakeupDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.utility.WAKEUP_DEVICE}`, 'POST');

  const handleSleepDevice = () => {
    if (selectedVehicle && isWakeUpDeviceEnabled(selectedVehicle)) {
      const payload = {
        vehicleId: selectedVehicle.vehicleRegistrationNo,
        fleetId: user?.customer_id,
      };
      fetchSleepDeviceData(payload);
      setAnchorEl(null);
    }
  };

  // Check if wake-up was triggered for this vehicle using predefined fields
  const isWakeUpDeviceEnabled = (vehicle: any) => {
    if (!vehicle) return false;

    console.info('Wake-up status check for vehicle:', vehicle.vehicleRegistrationNo, {
      isDeviceWakeupTriggered: vehicle.isDeviceWakeupTriggered,
      deviceWakeupTriggered: vehicle.deviceWakeupTriggered,
      dataSource: vehicle.dataSource,
    });

    // Check either of the predefined boolean fields
    return vehicle.isDeviceWakeupTriggered === true || vehicle.deviceWakeupTriggered === true;
  };

  const handleWakeupDevice = () => {
    if (selectedVehicle && !isWakeUpDeviceEnabled(selectedVehicle)) {
      const currentVehicleId = selectedVehicle.vehicleRegistrationNo;
      const payload = {
        vehicleId: currentVehicleId,
        fleetId: user?.customer_id,
      };
      setWakeupSendingVehicleIds((prev) =>
        prev.includes(currentVehicleId) ? prev : [...prev, currentVehicleId],
      );
      fetchWakeupDeviceData(payload);
    }
  };

  const [callModalOpen, setCallModalOpen] = useState(false);

  const handleCalling = () => {
    setCallModalOpen(true);
  };

  const viewMenuData = [
    {
      name: 'View Vehicle Details',
      icon: eye,
      click: () => {
        if (selectedVehicle) {
          navigate('details', { state: selectedVehicle });
        } else {
          console.error('Vehicle data is undefined');
        }
      },
      disabled: false,
    },
    { name: 'Dashboard', icon: dashboard, click: navigateToDasboard, disabled: false },
    {
      name: 'Share Vehicle Details',
      icon: share,
      click: isShareLikOpen ? handelShareLinkModalClose : handelShareLinkModalOpen,
      disabled: false,
    },
    {
      name: 'Download Vehicle Details',
      icon: download,
      click: () => {
        setSingleVehicleDownload(true);
        setIsDownloadModalOpen(true);
      },
      disabled: false,
    },
    {
      name: 'Live footage',
      icon: live,
      click: () => handleLiveFeedOpen(selectedVehicle.vehicleRegistrationNo),
      disabled: false,
    },
    {
      name: '2 way Communication',
      icon: callingIcon,
      click: () => handleCalling(),
      disabled: false,
    },
    // { name: 'Edit Vehicle', icon: edit, click: navigateToEdit, disabled: false },
    {
      name: 'Vehicle Current Location',
      icon: location,
      click: () => {
        setVehicleLocationModalOpen(true);
        setAnchorEl(null);
      },
      disabled: false,
    },
    // Show Wake-up and Sleep Device buttons only when dataSource === 'android'
    ...[
      {
        name:
          selectedVehicle && wakeupSendingVehicleIds.includes(selectedVehicle.vehicleRegistrationNo)
            ? 'Sending Command...'
            : 'Wake-up Device',
        icon: require('packages/novous_web/src/assets/images/green start.png'),
        click: handleWakeupDevice,
        disabled:
          (selectedVehicle && wakeupSendingVehicleIds.includes(selectedVehicle.vehicleRegistrationNo)) ||
          isWakeUpDeviceEnabled(selectedVehicle),
      },
      {
        name: 'Sleep Device',
        icon: require('packages/novous_web/src/assets/images/red stop.png'),
        click: handleSleepDevice,
        disabled: !isWakeUpDeviceEnabled(selectedVehicle), // Disabled when wake-up is not triggered
      },
    ],
    // { name: 'Delete Vehicle', icon: Delete, click: () => { setIsDeleteModalOpen(true); setAnchorEl(null) } },
  ];
  const {
    data: vehicleData,
    error: routesError,
    loading: routesLoading,
    fetchData: fetchVehicleData,
  } = useAxios<any>(`${API_ENDPOINTS.dashboard.FLEET_ALL_STATUS}`, 'POST');
  const {
    data: downloadVehicleData,
    error: downloadVehicleError,
    loading: downloadVehicleLoading,
    fetchData: fetchDownloadVehicleData,
  } = useApiError<any>(`${API_ENDPOINTS.directories.VEHICLE_DOWNLOAD}`, 'POST', 'blob');

  const {
    data: sleepDeviceData,
    error: sleepDeviceError,
    loading: sleepDeviceLoading,
    fetchData: fetchSleepDeviceData,
  } = useAxios<any>(`${API_ENDPOINTS.utility.SLEEP_DEVICE}`, 'POST');

  useEffect(() => {
    paginatedArr.current = [null];
    setCurrentPage(1);
    setPagesData([]);
  }, [user?.customer_id]);

  const {
    data: liveStreamStopData,
    error: liveStreamStopError,
    loading: liveStreamStopLoading,
    fetchData: fetchLiveStreamStopData,
  } = useAxios<{ data: any }>(
    `${API_ENDPOINTS.dashboard.STOP_LIVE_STREAMING}${vehicleLive?.vehicleRegNo}`,
    'GET',
  );

  useEffect(() => {
    if (downloadVehicleError) {
      setToast({
        open: true,
        message: 'Error occurred while downloading vehicle data.',
        type: 'error',
      });
    }
  }, [downloadVehicleError]);

  useEffect(() => {
    if (wakeupDeviceData?.status === 200) {
      setToast({
        open: true,
        message: wakeupDeviceData?.message,
        type: 'success',
      });
      setAnchorEl(null);
      if (selectedVehicle?.vehicleRegistrationNo) {
        const doneId = selectedVehicle.vehicleRegistrationNo;
        setWakeupSendingVehicleIds((prev) => prev.filter((id) => id !== doneId));
      }
      // The wake-up status will be reflected in the API response's predefined fields
      // No need to manually track state - refetch vehicle data to get updated status
      if (selectedVehicle && user?.customer_id) {
        fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
      }
    } else if (wakeupDeviceError) {
      setToast({
        open: true,
        message: 'Error occurred while sending wake-up command to device.',
        type: 'error',
      });
      setAnchorEl(null);
      if (selectedVehicle?.vehicleRegistrationNo) {
        const errorId = selectedVehicle.vehicleRegistrationNo;
        setWakeupSendingVehicleIds((prev) => prev.filter((id) => id !== errorId));
      }
    }
  }, [wakeupDeviceData, wakeupDeviceError]);

  useEffect(() => {
    if (sleepDeviceData?.status === 200) {
      setToast({
        open: true,
        message: sleepDeviceData?.message,
        type: 'success',
      });
      // The wake-up status will be reflected in the API response's predefined fields
      // No need to manually track state - refetch vehicle data to get updated status
      if (selectedVehicle && user?.customer_id) {
        fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
      }
    } else if (sleepDeviceError) {
      setToast({
        open: true,
        message: 'Error occurred while sending sleep command to device.',
        type: 'error',
      });
    }
  }, [sleepDeviceData, sleepDeviceError]);

  useEffect(() => {
    if (vehicleData?.data) {
      console.info('Raw vehicle data from API:', vehicleData.data);

      const vehicleListData: Vehicle[] = vehicleData?.data?.map((vehicle: any) => {
        console.info('Processing vehicle:', vehicle.vehicleRegistrationNo, {
          isDeviceWakeupTriggered: vehicle.isDeviceWakeupTriggered,
          deviceWakeupTriggered: vehicle.deviceWakeupTriggered,
          devicewakeuptrigger: vehicle.devicewakeuptrigger,
          dataSource: vehicle.dataSource,
        });

        return {
          vehicleName: vehicle.vehicleName,
          driverName: vehicle.driverName,
          gpsSpeed: vehicle.gpsSpeed,
          vehicleRegistrationNo: vehicle.vehicleRegistrationNo,
          vehicleType: vehicle.vehicleType,
          lastLocationAddress: vehicle.lastLocationAddress,
          vehicleState: vehicle.vehicleState,
          lastLatitude: vehicle.lastLatitude,
          lastLongitude: vehicle.lastLongitude,
          chassisNo: vehicle.chassisNo,
          deviceType: vehicle.deviceType,
          modelYear: vehicle.modelYear,
          model: vehicle.model,
          vehicleManufacturer: vehicle.vehicleManufacturer,
          groupName: vehicle.groupName,
          lastUpdateTime: vehicle.lastUpdateTime,
          deviceId: vehicle.deviceId,
          tripStatus: vehicle.tripStatus,
          totalKmToday: vehicle.totalKmToday,
          tripName: vehicle.tripName,
          tripId: vehicle.tripId,
          isDeviceWakeupTriggered: vehicle.isDeviceWakeupTriggered ?? false,
          deviceWakeupTriggered: vehicle.deviceWakeupTriggered ?? false,
          dataSource: vehicle.dataSource,
          vehicleProductType: vehicle.vehicleProductType,
        };
      });
      setData(vehicleListData);
      const mappedData: MapData[] = vehicleData?.data?.map((vehicle: any) => ({
        vehicleRegistrationNo: vehicle.vehicleRegistrationNo,
        lastLocationAddress: vehicle.lastLocationAddress,
        vehicleState: vehicle.vehicleState,
        lastLatitude: vehicle.lastLatitude,
        lastLongitude: vehicle.lastLongitude,
        deviceId: vehicle.deviceId,
        lastUpdateTime: vehicle.lastUpdateTime,
        gpsSpeed: vehicle.gpsSpeed,
        vehicleType: vehicle.vehicleType,
        deviceType: vehicle.deviceType,
        groupName: vehicle.groupName,
        vehicleProductType: vehicle.vehicleProductType,
      }));
      setMapData(mappedData);
    }
  }, [vehicleData]);

  useEffect(() => {
    if (selectedVehicle) {
      setVehicleLive({
        vehicleRegNo: selectedVehicle?.vehicleRegistrationNo,
        vehicleId: selectedVehicle?.vehicleRegistrationNo,
      });
    } else {
      setVehicleLive({ vehicleRegNo: '' });
    }
  }, [selectedVehicle]);

  const handleOpenMenu = (event: React.MouseEvent<HTMLSpanElement>, vehicle: any) => {
    setAnchorEl(event.currentTarget);
    setSelectedVehicle(vehicle);
  };
  useEffect(() => {
    if (vehicleData?.data?.lastEvaluatedKey) {
      if (paginatedArr.current.length === currentPage) {
        paginatedArr.current.push(vehicleData.data.lastEvaluatedKey);
      }
    }
  }, [vehicleData]);

  useEffect(() => {
    if (vehicleData) {
      setPagesData((prev) => {
        const newPages = [...prev];
        newPages[currentPage - 1] = vehicleData.data;
        return newPages;
      });
    }
  }, [vehicleData, currentPage]);
  const totalPages = useRef(paginatedArr.current.length);
  useEffect(() => {
    console.info('dtaa', data[0]);
    if (debouncedSearchQuery) {
      const filteredDataArr = data.filter(
        (vehicle) =>
          vehicle?.vehicleRegistrationNo?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
          vehicle?.vehicleName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
          vehicle?.driverName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
          vehicle?.vehicleState?.toLowerCase()?.includes(searchQuery?.toLowerCase()),
      );
      setCurrentPage(1);
      totalPages.current = 1;
      setFilteredData(filteredDataArr);
    } else {
      setFilteredData(data);
    }
  }, [debouncedSearchQuery, data]);
  const handleDriveDoc = (files: string[]) => {
    console.info(files, 'fles   ');

    setDriverDoc(files);
    setToast({ open: true, message: 'Driver Docs Uploaded Successfully', type: 'success' });
  };

  const mapViewColumns: MRT_ColumnDef<Vehicle>[] = useMemo(
    () => [
      {
        accessorKey: 'vehicleRegistrationNo',
        header: 'Vehicle Reg No.',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: {
          sx: { maxWidth: '120px', padding: '6px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography
            variant="body2"
            fontWeight={400}
            onClick={() => {
              setVehicleFoucLocation({
                lat: Number(cell.row.original.lastLatitude),
                lng: Number(cell.row.original.lastLongitude),
              });
              console.info(`You clicked on name: ${cell.getValue<string>()}`);
            }}
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
              fontWeight: 'bold',
              '&:hover': {
                color: 'primary.dark',
              },
            }}
          >
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'vehicleState',
        header: 'Vehicle Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '6px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 60 : 100,
        Cell: ({ cell }) => {
          const status = cell.getValue<string>().trim().toUpperCase();
          let backgroundColor;
          switch (status) {
            case 'STOP':
              backgroundColor = '#FF0000';
              break;
            case 'MOVING':
              backgroundColor = '#4CAF50';
              break;
            case 'IDLE':
              backgroundColor = '#808080';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          return (
            <div
              style={{
                backgroundColor: backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '60px',
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" fontWeight={500}>
                {status}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'lastUpdateTime',
        header: 'Last Updated Time',
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 130,
        muiTableBodyCellProps: { sx: { padding: '6px' } },
        Cell: ({ cell }) => {
          const timestamp = cell.getValue<string>();

          const formatDateTime = (timestamp: string) => {
            if (!timestamp) return 'N/A';

            try {
              const [datePart, ...timeParts] = timestamp.split(':');
              if (timeParts.length < 3) return timestamp;

              const [hours, minutes, seconds] = timeParts;
              const [year, month, day] = datePart.split('-');
              const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
              const dayWithSuffix = `${parseInt(day)}${getOrdinalSuffix(parseInt(day))}`;
              const monthName = date.toLocaleString('default', { month: 'long' });
              const formattedTime = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(
                2,
                '0',
              )}`;

              return `${dayWithSuffix} ${monthName} ${formattedTime}`;
            } catch (error) {
              console.error('Error formatting timestamp:', error);
              return timestamp;
            }
          };
          const getOrdinalSuffix = (day: number) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
              case 1:
                return 'st';
              case 2:
                return 'nd';
              case 3:
                return 'rd';
              default:
                return 'th';
            }
          };

          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {timestamp ? formatDateTime(timestamp) : 'N/A'}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        muiTableBodyCellProps: {
          sx: {
            padding: '6px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography
              variant="body2"
              fontWeight={700}
              color="primary"
              sx={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.stopPropagation();
                console.info('IconButton clicked');
                if (row.original) {
                  navigate('dashboard', { state: row.original });
                } else {
                  console.error('Row data is undefined');
                }
              }}
            >
              Dashboard
            </Typography>
            <IconButton
              sx={{
                padding: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
                borderRadius: '2px',
              }}
              onClick={(event) => handleOpenMenu(event, row.original)}
            >
              <img src={menu} alt="custom action" />
            </IconButton>
          </Box>
        ),
      },
    ],
    [],
  );
  useEffect(() => {
    handleTile(tilesObj);
  }, [tilesObj]);
  const columns: MRT_ColumnDef<Vehicle>[] = useMemo(
    () => [
      {
        accessorKey: 'vehicleRegistrationNo',
        header: 'Vehicle Reg No.',
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400}>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'vehicleState',
        header: 'Vehicle Status',
        muiTableBodyCellProps: {
          sx: {
            padding: '6px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        Cell: ({ cell }) => {
          const status = cell.getValue<string>().trim().toUpperCase();
          let backgroundColor;
          switch (status) {
            case 'STOP':
              backgroundColor = '#FF0000';
              break;
            case 'MOVING':
              backgroundColor = '#4CAF50';
              break;
            case 'IDLE':
              backgroundColor = '#808080';
              break;
            default:
              backgroundColor = '#E0ECFD';
          }

          return (
            <div
              style={{
                backgroundColor: backgroundColor,
                padding: '4px 8px',
                borderRadius: '12px',
                display: 'inline-block',
                minWidth: '80px',
                textAlign: 'center',
              }}
            >
              <Typography variant="body2" fontWeight={500}>
                {status}
              </Typography>
            </div>
          );
        },
      },
      {
        accessorKey: 'lastUpdateTime',
        header: 'Last Updated Time',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => {
          const timestamp = cell.getValue<string>();

          const formatDateTime = (timestamp: string) => {
            if (!timestamp) return 'N/A';

            try {
              // First split the timestamp into date and time parts
              const [datePart, ...timeParts] = timestamp.split(':');

              // If we don't have enough time parts, return the raw value
              if (timeParts.length < 3) return timestamp;

              const [hours, minutes, seconds] = timeParts;

              // Split the date part
              const [year, month, day] = datePart.split('-');

              // Create a Date object for month name (months are 0-indexed)
              const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));

              // Format the day with ordinal suffix
              const dayWithSuffix = `${parseInt(day)}${getOrdinalSuffix(parseInt(day))}`;

              // Get month name
              const monthName = date.toLocaleString('default', { month: 'long' });

              // Format the time
              const formattedTime = `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}:${seconds.padStart(
                2,
                '0',
              )}`;

              return `${dayWithSuffix} ${monthName} ${formattedTime}`;
            } catch (error) {
              console.error('Error formatting timestamp:', error);
              return timestamp; // Return original value if formatting fails
            }
          };

          // Helper function to get ordinal suffix
          const getOrdinalSuffix = (day: number) => {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
              case 1:
                return 'st';
              case 2:
                return 'nd';
              case 3:
                return 'rd';
              default:
                return 'th';
            }
          };

          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {timestamp ? formatDateTime(timestamp) : 'N/A'}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'gpsSpeed',
        header: 'Last Received Speed',
        enableColumnActions: false,
        size: isSmallScreen ? 100 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<number>()} Km/h
          </Typography>
        ),
      },
      {
        accessorKey: 'deviceId',
        header: 'Device Id',
        enableColumnActions: false,
        size: isSmallScreen ? 100 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'tripStatus',
        header: 'Trip Status',
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },

      {
        accessorKey: 'vehicleType',
        header: 'Vehicle Icon',
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => {
          const vehicleType = cell.getValue<string>();
          const vehicleOptions: any = {
            CAB: car,
            MINBUS: minivan,
            TRUCK: truck,
            BUS: bus,
          };

          return (
            <div className="flex items-center gap-2">
              {vehicleOptions[vehicleType] ? (
                <img
                  src={vehicleOptions[vehicleType]}
                  alt={vehicleType}
                  style={{ width: '32px', height: '32px' }}
                />
              ) : (
                <Typography variant="body2" fontWeight={400} noWrap>
                  {vehicleType}
                </Typography>
              )}
            </div>
          );
        },
      },
      {
        accessorKey: 'lastLocationAddress',
        header: 'Last Location',
        enableColumnActions: false,
        size: isSmallScreen ? 150 : 300,
        muiTableBodyCellProps: { sx: { padding: '8px', maxWidth: { xs: '180px', md: '320px' } } },
        Cell: ({ row }) => {
          const lat = row.original.lastLatitude;
          const lon = row.original.lastLongitude;
          const [address, setAddress] = useState<string>('Loading...');
          const [error, setError] = useState<string | null>(null);

          useEffect(() => {
            const fetchAddress = async () => {
              setAddress('Loading...');
              if (lat === '0' || lon === '0' || lat === '' || lon === '') {
                setAddress('NA');
                return;
              }

              try {
                const response = await axisInstance({
                  url: API_ENDPOINTS.google.GOOGLE_ADDRESS,
                  method: 'POST',
                  data: {
                    latitude: parseFloat(lat),
                    longitude: parseFloat(lon),
                  },
                  responseType: 'json',
                });

                const result = response.data;

                if (result?.status === 200 && result?.data) {
                  setAddress(result.data);
                } else {
                  setAddress('NA');
                }
              } catch (err) {
                console.error('Error fetching address:', err);
                setError('Error fetching address');
                setAddress('NA');
              }
            };

            fetchAddress();
          }, [lat, lon]);

          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {error ? error : address}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'driverName',
        header: 'Driver Name',
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'groupName',
        header: 'Depot Name',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => {
          const groupNames = cell.getValue<string>();
          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {groupNames ? groupNames : 'NA'}
            </Typography>
          );
        },
      },
      {
        accessorKey: 'vehicleProductType',
        header: 'Vehicle Product Type',
        enableColumnActions: false,
        size: isSmallScreen ? 90 : 150,
        muiTableBodyCellProps: { sx: { padding: '8px' } },
        Cell: ({ cell }) => {
          const productType = cell.getValue<string>();
          return (
            <Typography variant="body2" fontWeight={400} noWrap>
              {productType ? productType : 'NA'}
            </Typography>
          );
        },
      },

      {
        accessorKey: 'vehicleName',
        header: 'Vehicle Name',
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        muiTableBodyCellProps: {
          sx: { maxWidth: '150px', padding: '8px', overflow: 'hidden' },
        },
        Cell: ({ cell }) => (
          <Typography variant="body2" fontWeight={400} noWrap>
            {cell.getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'actions',
        header: 'Actions',
        muiTableBodyCellProps: {
          sx: {
            padding: '6px',
          },
        },
        enableColumnActions: false,
        size: isSmallScreen ? 80 : 140,
        Cell: ({ row }) => (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 2,
            }}
          >
            <Typography
              variant="body2"
              fontWeight={700}
              color="primary"
              sx={{ cursor: 'pointer' }}
              onClick={(event) => {
                event.stopPropagation();
                console.info('IconButton clicked');
                if (row.original) {
                  navigate('dashboard', { state: row.original });
                } else {
                  console.error('Row data is undefined');
                }
              }}
            >
              Dashboard
            </Typography>
            <IconButton
              sx={{
                padding: 1,
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
                borderRadius: '2px',
              }}
              onClick={(event) => handleOpenMenu(event, row.original)}
            >
              <img src={menu} alt="custom action" />
            </IconButton>
          </Box>
        ),
      },
    ],
    [],
  );

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleLiveFeedClose = () => {
    fetchLiveStreamStopData();
    setIsLiveFeedOpen({ isOpen: false, vehicleId: '' });
  };
  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => {
    setCurrentPage(page);
  };
  const handleReset = () => {
    // Reset columnObj to show all columns
    setColumnObj({
      vehicleName: { name: 'Vehicle Name', status: true },
      driverName: { name: 'Driver Name', status: true },
      gpsSpeed: { name: 'Vehicle Speed', status: true },
      deviceId: { name: 'Device Id', status: true },
      lastUpdateTime: { name: 'Last Updated Time', status: true },
      vehicleRegistrationNo: { name: 'Vehicle Reg No', status: true },
      vehicleType: { name: 'Vehicle Icon', status: true },
      vehicleState: { name: 'Vehicle Status', status: true },
      lastLocationAddress: { name: 'Last Location', status: true },
      tripStatus: { name: 'Trip Status', status: true },
      actions: { name: 'Actions', status: true },
    });

    // Reset tilesObj to show all tiles
    setTilesObj({
      Stat1: { name: 'Total Vehicles', status: true },
      Stat2: { name: 'Active Vehicles', status: true },
      Stat3: { name: 'Available Vehicles', status: true },
      Stat4: { name: 'Maintenance Vehicles', status: true },
    });
  };
  const vehicleColumns: MRT_ColumnDef<Vehicle>[] = useMemo(() => {
    return columns.filter((column) => {
      const key = column.accessorKey as keyof ColumnObjType;
      return columnObj[key]?.status;
    });
  }, [columns, columnObj]);

  const dynamicTableOptions = mapView
    ? {}
    : {
        enableColumnPinning: isSmallScreen ? false : true,
        ...(isSmallScreen
          ? {}
          : {
              state: {
                columnPinning: {
                  left: ['vehicleRegistrationNo', 'vehicleState', 'lastUpdateTime'],
                  right: ['actions'],
                },
              },
            }),
        muiTableProps: {
          sx: {
            overflow: 'scroll',
          },
        },
      };

  const tableOptions: MRT_TableOptions<Vehicle> = {
    columns: mapView ? mapViewColumns : vehicleColumns,
    data: paginatedData,
    enablePagination: false,
    enableColumnFilters: false,
    enableSorting: false,
    enableGlobalFilter: false,
    enableDensityToggle: false,
    enableHiding: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    enableFullScreenToggle: false,
    enableToolbarInternalActions: false,
    muiTableBodyProps: {
      sx: {
        padding: 0,
        margin: 0,
      },
    },
    ...dynamicTableOptions,
  };

  const table = useMaterialReactTable(tableOptions);

  const handleOpen = () => setIsCustomiseModalOpen(true);
  const handleClose = () => setIsCustomiseModalOpen(false);

  const handleFormatChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedFormat(event.target.value);
  };

  // const handleDownload = async () => {
  //     if (singleVehicleDownload) {
  //         fetchDownloadVehicleData({ fleetId: user?.customer_id, fileType: selectedFormat, vehicleId: selectedVehicle?.vehicleRegistrationNo });
  //         setAnchorEl(null);
  //     } else {
  //         fetchDownloadVehicleData({ fleetId: user?.customer_id, fileType: selectedFormat });
  //     }
  // };

  const handleDownload = async () => {
    setIsSendingEmail(true);
    const requestData = {
      fleetId: user?.customer_id,
      fileType: selectedFormat,
      vehicleId: selectedVehicle?.vehicleRegistrationNo,
    };

    const responseData = {
      fleetId: user?.customer_id,
      fileType: selectedFormat,
    };

    if (singleVehicleDownload) {
      try {
        const response = await fetchDownloadVehicleData(requestData);
        if (
          response?.type === 'text/csv' ||
          response?.type === 'application/pdf' ||
          response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) {
          setAlertMessage(`File has been downloaded successfully`);
          setAlertType('success');
          setAlertOpen(true);
        } else {
          setAlertMessage(response?.error);
          setAlertType('error');
          setAlertOpen(true);
        }
      } catch (error) {
        console.error('Error sending email:', error);
        setAlertMessage((error as Error).message);
        setAlertType('error');
        setAlertOpen(true);
      } finally {
        setIsSendingEmail(false);
      }
    } else {
      try {
        const response = await fetchDownloadVehicleData(responseData);
        if (
          response?.type === 'text/csv' ||
          response?.type === 'application/pdf' ||
          response?.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ) {
          setAlertMessage(`File has been downloaded successfully`);
          setAlertType('success');
          setAlertOpen(true);
        } else {
          setAlertMessage(response?.error);
          setAlertType('error');
          setAlertOpen(true);
        }
      } catch (error) {
        console.error('Error sending email:', error);
        setAlertMessage((error as Error).message);
        setAlertType('error');
        setAlertOpen(true);
      } finally {
        setIsSendingEmail(false);
      }
    }
  };

  useEffect(() => {
    if (downloadVehicleData) {
      try {
        if (downloadVehicleData instanceof Blob) {
          const url = window.URL.createObjectURL(downloadVehicleData);
          const a = document.createElement('a');
          a.href = url;
          let extension = selectedFormat.toLowerCase();
          if (extension === 'excel') {
            extension = 'xlsx'; // Use xlsx for Excel format
          }

          const fileName = `vehicle_data.${extension}`;
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        } else {
          console.error('Invalid response format. Expected a Blob.');
        }
      } catch (error) {
        console.error('Error downloading file:', error);
      } finally {
        setIsDownloadModalOpen(false);
      }
    }
  }, [downloadVehicleData]);

  const handleDownloadModalClose = () => {
    setIsDownloadModalOpen(false);
  };

  const handleUploadModalClose = () => {
    setIsUploadModelOpen(false);
    fetchVehicleData({ fleetId: user?.customer_id, lastEvaluatedKey: null });
  };

  return (
    <>
      <AlertToast
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={() => setAlertOpen(false)}
      />
      <div className="flex flex-col gap-4 w-full">
        {/* Search Input */}
        {/* {!mapView && ( */}
        <div className="w-full flex flex-col lg:flex-row justify-between gap-4">
          <div className="flex w-full lg:w-auto">
            <div className="w-full lg:max-w-[400px]">
              <TextField
                variant="outlined"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search"
                sx={(theme) => ({
                  '& .MuiOutlinedInput-root': {
                    borderColor: theme.palette.action.selected,
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    height: '100%',
                  },
                  '& .MuiInputBase-root': {
                    padding: '0rem 1rem',
                  },
                  '& .MuiOutlinedInput-input': {
                    padding: '0px 12px',
                    height: '48px',
                    display: 'flex',
                    alignItems: 'center',
                  },
                })}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <img src={searchIcon} alt="icon" width={16} height={16} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment
                      position="end"
                      sx={(theme) => ({
                        height: '48px',
                        maxHeight: '48px',
                        display: 'flex',
                        alignItems: 'center',
                        borderLeft: `1px solid ${theme.palette.action.selected}`,
                        paddingLeft: '8px',
                      })}
                    >
                      <img
                        src={filterIcon}
                        alt="icon"
                        width={24}
                        height={24}
                        onClick={() => setIsFilterModelOpen(true)}
                      />
                    </InputAdornment>
                  ),
                }}
                inputProps={{
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    fontSize: '14px',
                    fontWeight: 500,
                  },
                }}
              />
            </div>
            {filterData.isfiltered && (
              <CustomIconButton
                text={`Clear Filters (${
                  Object.values(filterData.data).filter((value) => value !== null).length
                })`}
                background="transparent"
                outline={false} // Set to true if you want an outline
                textColor="#C83333"
                onClick={() => setFilterData({ data: {}, isfiltered: false })}
              />
            )}
          </div>
          {/* {!mapView && ( */}
          <div className="flex gap-4 flex-wrap w-full lg:w-auto">
            <CustomIconButton
              icon={<img src={Custom} alt="Custom" width={16} height={16} />}
              text="Customize"
              background="transparent"
              outline={false}
              onClick={handleOpen}
            />
            <CustomIconButton
              icon={<img src={bulkUpload} alt="download" width={24} height={24} />}
              text="Bulk Upload"
              background="transparent"
              outline={false}
              onClick={() => setIsUploadModelOpen(true)}
            />
            <CustomIconButton
              icon={
                <img
                  src={download}
                  alt="download"
                  width={16}
                  height={16}
                  style={filteredData.length === 0 ? { filter: 'grayscale(1)', opacity: 0.5 } : undefined}
                />
              }
              text="Download"
              background="transparent"
              variant="outlined"
              isDisabled={filteredData.length === 0}
              onClick={() => setIsDownloadModalOpen(true)}
            />
            <CustomIconButton
              icon={<img src={play} alt="download" width={16} height={16} />}
              text="Videos Playback"
              background="transparent"
              variant="outlined"
              onClick={() => navigate('videos-playback')}
            />
            <CustomIconButton
              icon={<img src={add} alt="download" width={16} height={16} />}
              text="Add Vehicle"
              variant="contained"
              onClick={() => navigate('new')}
            />
          </div>
        </div>

        <Box
          display="flex"
          flexDirection={mapView && !isSmallScreen ? 'row' : 'column'}
          gap={2}
          width="100%"
          sx={{
            ...(mapView &&
              !isSmallScreen && {
                height: 'calc(100vh - 20rem)',
                overflow: 'hidden',
              }),
          }}
        >
          <Box
            flex={mapView && !isSmallScreen ? '1' : 'auto'}
            width={mapView && !isSmallScreen ? '50%' : '100%'}
            sx={{
              overflow: 'scroll',
            }}
          >
            <MaterialReactTable key={mapView} table={table} />
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
              {viewMenuData.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={item.disabled ? undefined : item.click}
                  disabled={item.disabled}
                  sx={{
                    opacity: item.disabled ? 0.6 : 1,
                    cursor: item.disabled ? 'not-allowed' : 'pointer',
                    '&:hover': {
                      backgroundColor: item.disabled ? 'transparent' : 'rgba(0, 0, 0, 0.04)',
                    },
                  }}
                >
                  <div className="flex gap-2 mt-1">
                    <img
                      src={item.icon}
                      alt={item.name}
                      style={{
                        marginRight: 8,
                        width: 20,
                        height: 20,
                      }}
                    />
                    <Typography variant="body2" fontWeight={600}>
                      {item.name}
                    </Typography>
                  </div>
                </MenuItem>
              ))}
            </Menu>

            <Box display="flex" justifyContent="center" mt={2}>
              <Pagination
                count={
                  Math.ceil(filteredData.length / pageSize) == 0
                    ? 1
                    : Math.ceil(filteredData.length / pageSize)
                }
                page={currentPage}
                onChange={handlePageChange}
                shape="rounded"
                color="primary"
                siblingCount={0}
                boundaryCount={0}
                renderItem={(item) => {
                  if (item.type === 'page' && item.page !== null && item.page > currentPage) {
                    return null;
                  }
                  return <PaginationItem {...item} />;
                }}
              />
            </Box>
          </Box>
          {mapView && (
            <Box
              width={!isSmallScreen ? '50%' : '100%'}
              mt={2}
              flex={!isSmallScreen ? '1' : 'auto'}
              sx={{
                overflow: 'hidden',
              }}
            >
              <MapPreview
                mapData={mapData}
                showStop={true}
                zoomRatio={4.5}
                focusLocation={vehicleFoucLocation}
                height={isSmallScreen ? 'h-[341px]' : 'full'}
              />
            </Box>
          )}
        </Box>

        <CallingModal tripInfo={vehicleLive} open={callModalOpen} onClose={() => setCallModalOpen(false)} />

        {isLiveFeedOpen && (
          <LiveFeedModal
            trip={vehicleLive}
            open={isLiveFeedOpen.isOpen}
            onClose={handleLiveFeedClose}
            isDash={true}
            vehicleId={selectedVehicle?.deviceId}
            deviceType={selectedVehicle?.deviceType}
          />
        )}
        <Dialog
          open={isDeleteModalOpen}
          onClose={handleDeleteCancel}
          aria-labelledby="delete-dialog-title"
          aria-describedby="delete-dialog-description"
        >
          <DialogTitle id="delete-dialog-title">Delete Vehicle</DialogTitle>
          <DialogContent>
            <DialogContentText id="delete-dialog-description">
              Are you sure you want to delete this vehicle?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDeleteCancel} color="primary">
              Cancel
            </Button>
            <Button onClick={handleDeleteConfirm} color="error" autoFocus>
              Delete
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={isVehicleLocationModalOpen}
          onClose={handleVehicleLocationCancel}
          aria-labelledby="vehicleLocation-dialog-title"
          aria-describedby="vehicleLocation-dialog-description"
          fullWidth
          maxWidth="md"
        >
          <DialogTitle id="vehicleLocation-dialog-title">{selectedVehicle?.vehicleName || 'NA'}</DialogTitle>
          <DialogContent>
            <DialogContentText id="vehicleLocation-dialog-description">
              {selectedVehicle?.vehicleRegistrationNo || 'NA'}
            </DialogContentText>
            <Box
              sx={{
                width: '100%', // Takes full width of DialogContent
                height: '750px',
                mt: 2,
              }}
            >
              <MapPreview mapData={[selectedVehicle]} showStop={true} zoomRatio={20} />
            </Box>
          </DialogContent>
        </Dialog>
        <Dialog
          open={isDownloadModalOpen}
          onClose={handleDownloadModalClose}
          aria-labelledby="download-modal-title"
        >
          <DialogTitle id="download-modal-title">
            <Typography variant="h6" fontWeight={600}>
              Download Vehicles Data
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>Please select a file format for your download.</DialogContentText>
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <Typography variant="body1" fontWeight={500} gutterBottom>
                Format
              </Typography>
              <RadioGroup
                aria-label="format"
                name="format"
                value={selectedFormat}
                onChange={handleFormatChange}
                row // Display radio buttons in a row
              >
                <FormControlLabel value="excel" control={<Radio />} label="Excel" />
                <FormControlLabel value="csv" control={<Radio />} label="CSV" />
                <FormControlLabel value="pdf" control={<Radio />} label="PDF" />
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleDownloadModalClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleDownload} color="primary" variant="contained">
              {downloadVehicleLoading ? 'Downloading...' : 'Download'}
            </Button>
          </DialogActions>
        </Dialog>
        <AlertToast
          open={toast.open}
          message={toast.message}
          onClose={() => setToast((prev) => ({ ...prev, open: false }))}
          type={toast.type as any}
        />
        <CustomiseTableModal
          open={isCustomiseModalOpen}
          onClose={handleClose}
          onReset={handleReset}
          title="Customize Your Table"
          description="Select and arrange table columns as you prefer."
          columnObj={columnObj}
          setColumnObj={setColumnObj}
          tilesObj={tilesObj}
          setTilesObj={setTilesObj}
        />
        <AlertToast
          open={toast.open}
          message={toast.message}
          onClose={() => setToast((prev) => ({ ...prev, open: false }))}
          type={toast.type as any}
        />
        {isUploadModelOpen && (
          <BulkUploadModal
            open={isUploadModelOpen}
            handleClose={handleUploadModalClose}
            handleDriveDoc={driverDoc}
            uploadEndpoint={API_ENDPOINTS.directories.VEHICLE_BULK_UPLOAD}
            title="Bulk Upload"
            description="Upload an Excel/CSV files to add multiple vehicles at once!"
            entityType="vehicles"
            sampleFileUrl={API_ENDPOINTS.directories.VEHICLE_SAMPLE_DOWNLOAD}
          />
        )}
      </div>
      <FilterDataModel
        open={isFilterModel}
        onClose={handleFilterClose}
        handleFilterSave={handleFilterSave}
        title="Filter"
        description="Use the options below to refine your search and find specific trips quickly."
        showTripStatus={false}
        initialFilters={{
          group: filterData?.data?.group ?? null,
          tripStatus: filterData?.data?.tripStatus ?? null,
          vehicle: filterData?.data?.vehicle ?? null,
          alarm: filterData?.data?.alarm ?? null,
        }}
        trgtcData={true}
      />
      <ShareLinkModalBox
        open={isShareLikOpen}
        onClose={handelShareLinkModalClose}
        heading="Share Vehicle Details"
        subheading="Select Date & Time to generate shareable link"
        shareLink={shareLink}
        vehicleId={selectedVehicle?.vehicleRegistrationNo}
      />
    </>
  );
};

export default VehiclesDataTable;
